import React, { useContext } from "react";
import { useRef } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import globalContext from "../../Contexts/GlobalContext";
import ChangeKmModal from "../changeKmModal/ChangeKmModal";
import BlueLoader from "../loader/BlueLoader";
import { addCommas, p2e, removeNonNumeric } from "../../utils/functions";
export default function CarDetailsBox({
  mt,
  mb,
  forwardRef,
  logoUrl,
  kmCurrent,
  setLogoUrl,
  setKmCurrent,
}) {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const contextData = useContext(globalContext);
  ///----->
  const [logoSrc, setLogoSrc] = useState("");
  const [logoSrcMain, setLogoSrcMain] = useState("");
  const [kmC, setKmC] = useState(kmCurrent);
  ///----->
  useEffect(() => {
    if (kmCurrent) {
      setKmC(kmCurrent);
    }

    if (cookies?.kmCurrent) {
      setKmC(cookies?.kmCurrent);
    } else {
      setKmC(kmCurrent);
    }

    if (logoUrl) {
      setLogoSrc(logoUrl);
    }
    if (cookies?.logoUrlPices) {
      setLogoSrc(cookies?.logoUrlPices);
    } else {
      setLogoSrc(logoUrl);
    }
  }, [
    logoUrl,
    contextData.toggleNewCar,
    contextData.changeKmModalKM,
    kmCurrent,
  ]);
  const logoRef = useRef();

  useEffect(() => {
    if (logoUrl) {
      setLogoSrc(logoUrl);
    }

    if (logoSrc === null) {
      setLogoSrcMain("../assets/images/car-details/default logo.svg");
    } else {
      const img = new Image();
      img.src = logoSrc;

      if (img.complete) {
        setLogoSrcMain(logoSrc);
      } else {
        img.onload = () => {
          setLogoSrcMain(logoSrc);
        };
        img.onerror = () => {
          if (logoSrc) {
            setLogoSrcMain("../assets/images/car-details/default logo.svg");
          }
        };
      }
    }

    if (kmCurrent) {
      setKmC(kmCurrent);
    }
    if (cookies?.kmCurrent) {
      setKmC(cookies?.kmCurrent);
    } else {
      setKmC(kmCurrent);
    }
  }, [
    logoSrc,
    logoUrl,
    contextData.toggleNewCar,
    contextData.changeKmModalKM,
    kmCurrent,
  ]);

  return (
    <div
      ref={forwardRef}
      style={{ marginTop: `${mt}vw`, marginBottom: `${mb}vw` }}
      className="relative  flex items-center justify-center  "
    >
      <div className="w-[92.23312392649585vw] h-[19.22360321690526vw] ">
        <svg
          width="92.23312392649585vw"
          height="19.22360321690526vw"
          viewBox="0 0 392 83"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.11857 0.646721H136.716C155.407 6.63641 175.325 9.88383 195.964 9.88383C216.639 9.88383 236.557 6.63641 255.247 0.646721H383.845C388.247 0.646721 391.855 4.25497 391.855 8.62094V74.0745C391.855 78.4765 388.247 82.0487 383.845 82.0487H8.11857C3.71651 82.0487 0.144348 78.4405 0.144348 74.0745V8.62094C0.144348 4.21888 3.75259 0.646721 8.11857 0.646721Z"
            fill="#001D26"
            fillOpacity="0.701961"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.11857 0.646721H136.716C155.407 6.63641 175.325 9.88383 195.964 9.88383C216.639 9.88383 236.557 6.63641 255.247 0.646721H383.845C388.247 0.646721 391.855 4.25497 391.855 8.62094V74.0745C391.855 78.4765 388.247 82.0487 383.845 82.0487H8.11857C3.71651 82.0487 0.144348 78.4405 0.144348 74.0745V8.62094C0.144348 4.21888 3.75259 0.646721 8.11857 0.646721Z"
            stroke="#00FFF2"
            strokeWidth="0.28866"
            strokeMiterlimit="2.61313"
          />
        </svg>
      </div>

      <div
        className="absolute w-[15vw] h-[15vw] top-[2vw] right-[6vw] z-50"
        onClick={() => {
          navigate("/car-details");
        }}
      >
        {logoSrcMain ? (
          <img ref={logoRef} src={`${logoSrcMain}`} alt="" />
        ) : (
          <BlueLoader width={10} top={15} right={18} />
        )}
        {/* <img ref={logoRef} src={`${logoSrcMain}`} alt="" /> */}
      </div>
      <div
        className="absolute w-[13.23820754716981vw] h-[11.79245283018868vw] top-[3vw] left-[6.8vw] z-50"
        onClick={(e) => {
          e.stopPropagation();
          navigate("/add-car");
        }}
      >
        <div className="h-full w-full">
          <svg
            width="100%"
            height="100%"
            viewBox="0 0 57 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_315_2)">
              <path
                d="M37.4896 40.4388C37.4896 40.8608 37.2786 41.4937 36.8567 41.9156C36.4347 42.3376 36.0128 42.5486 35.3799 42.5486H7.10971C6.05485 42.5486 5 41.7047 5 40.4388C5 38.5401 5 35.1646 5 34.1097C5 32.8439 6.26583 32 7.10971 32C16.6034 32 30.7385 32 35.3799 32C36.6457 32 37.4896 33.2658 37.4896 34.1097C37.4896 36.4304 37.4896 39.384 37.4896 40.4388Z"
                fill="#00FFFF"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
              <path
                d="M8.03613 36.787C8.03613 35.5211 9.09099 34.4663 10.3568 34.4663C11.6226 34.4663 12.8884 35.5211 12.8884 36.787C12.8884 38.0528 11.8336 39.1076 10.3568 39.1076C9.09099 39.1076 8.03613 38.0528 8.03613 36.787Z"
                fill="black"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
              <path
                d="M15.6309 39.1076H26.3904V34.4663H15.6309V39.1076Z"
                fill="black"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
              <path
                d="M9.93457 26.8716H32.2975L30.3988 20.9644H11.8333L9.93457 26.8716Z"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
              <path
                d="M1 44.3799C1 46.9115 2.89874 48.8103 5.4304 49.0213C7.96205 49.2322 10.0718 47.3335 10.2827 45.0128H33.2786C33.7006 47.5445 35.8103 49.2322 38.131 49.0213C40.6626 48.8103 42.5614 46.9115 42.5614 44.3799V31.7216C42.5614 28.979 40.8736 26.4473 38.3419 25.3925L36.2322 18.6414C35.3883 15.8988 32.8567 14 29.9031 14H13.8693C10.9157 14 8.384 15.8988 7.54011 18.6414L5.4304 25.3925C2.89874 26.4473 1.21097 28.979 1.21097 31.7216V44.3799H1Z"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
              <path
                d="M44.9561 43.3274C47.4877 43.1164 49.3865 41.2177 49.3865 38.686V26.0277C49.3865 23.2851 47.6987 20.7534 45.167 19.6986L43.0573 12.9475C42.2134 10.2049 39.6818 8.30615 36.5172 8.30615H20.4834C17.5298 8.30615 14.9981 10.2049 14.1543 12.9475"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
              <path
                d="M52.3399 35.9431C54.8715 35.7321 56.7703 33.8334 56.7703 31.3017V18.6434C56.7703 15.9008 55.0825 13.3691 52.5508 12.5253L50.4411 5.77418C49.5972 3.03156 47.0656 1.13281 44.112 1.13281H28.0782C25.1246 1.13281 22.5929 3.03156 21.749 5.77418"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
              <path
                d="M34.407 36.787C34.407 35.5211 33.3521 34.4663 32.0863 34.4663C30.8205 34.4663 29.7656 35.5211 29.7656 36.787C29.7656 38.0528 30.8205 39.1076 32.0863 39.1076C33.3521 39.1076 34.407 38.0528 34.407 36.787Z"
                fill="black"
                stroke="#00FFFF"
                strokeWidth="0.632914"
                strokeMiterlimit="2.61313"
                strokeLinejoin="bevel"
              />
            </g>
            <defs>
              <clipPath id="clip0_315_2">
                <rect width="57" height="52" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>
      <div
        dir="ltr"
        className="absolute w-[92.23312392649585vw] h-[19.22360321690526vw]  text-[7vw] text-color-primary-D font-font_primary_D   flex items-center justify-center "
      >
        <span
          onClick={() => {
            contextData.setChangeKmModalIsOpen(true);
            contextData.setChangeKmModalKM(kmC);
          }}
        >
          {addCommas(removeNonNumeric(p2e(kmC)))}
        </span>
        &nbsp;
        {kmC && <span className="text-[5vw]">KM</span>}
      </div>
    </div>
  );
}
